import { MapPin, RefreshCw, Loader2, LocateFixed } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLang } from "@/context/LangContext";
import { placeLabel } from "@/lib/geocode";

// "Current location" header row: place name (reverse-geocoded), coordinates, refresh / allow-location actions.
export function HomeLocation({ pos, located, place, placeLoading, onRefresh }) {
  const { t } = useTranslation();
  const { tc } = useLang();
  const coords = pos ? `${pos[0].toFixed(3)}°, ${pos[1].toFixed(3)}°` : "";
  return (
    <div className="flex items-start gap-3" data-testid="home-location" data-status={located === null ? "locating" : located ? "ok" : "denied"}>
      <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary"><MapPin className="h-4 w-4" /></span>
      <div className="min-w-0 flex-1">
        <p className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">{tc({ id: "Lokasi saat ini", en: "Current location", ar: "الموقع الحالي" })}</p>
        {located === null ? (
          <p className="inline-flex items-center gap-1.5 text-sm text-muted-foreground" data-testid="home-location-name"><Loader2 className="h-3.5 w-3.5 animate-spin" />{t("locating")}</p>
        ) : pos ? (
          <>
            <p className="truncate text-sm font-medium" data-testid="home-location-name">
              {placeLoading ? <span className="inline-flex items-center gap-1.5 text-muted-foreground"><Loader2 className="h-3.5 w-3.5 animate-spin" />{coords}</span> : (placeLabel(place) || coords)}
            </p>
            {place && <p className="text-xs text-muted-foreground tabular-nums" data-testid="home-location-coords">{coords}</p>}
          </>
        ) : (
          <p className="text-sm text-muted-foreground" data-testid="home-location-name">{t("locationDenied")} Makkah</p>
        )}
      </div>
      {located === false ? (
        <button onClick={onRefresh} data-testid="home-location-allow" className="inline-flex h-8 shrink-0 items-center gap-1.5 rounded-full bg-primary px-3 text-xs font-medium text-white hover:opacity-90">
          <LocateFixed className="h-3.5 w-3.5" />{tc({ id: "Izinkan lokasi", en: "Allow location", ar: "السماح بالموقع" })}
        </button>
      ) : (
        <button onClick={onRefresh} disabled={located === null} aria-label={t("relocate")} title={t("relocate")} data-testid="home-location-refresh" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-border text-muted-foreground hover:bg-secondary disabled:opacity-40">
          <RefreshCw className={`h-3.5 w-3.5 ${located === null ? "animate-spin" : ""}`} />
        </button>
      )}
    </div>
  );
}
